import { render, staticRenderFns } from "./SizeSlider.vue?vue&type=template&id=544765f5&"
import script from "./SizeSlider.vue?vue&type=script&lang=js&"
export * from "./SizeSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports